import { Query, ResultSet } from "@cubejs-client/core";
import { AppThunk } from "appThunk";
import { cubeLoad } from "modules/helpers/cube/cubeSlice";
import { logError } from "modules/helpers/logger/loggerSlice";
import numberFormatter from "utils/numberFormatter";

export class SizeBucket {
    public readonly id: number;
    public readonly lowerBound: number;
    public readonly upperBound: number | null;
    public readonly label: string;

    constructor(
        id: number,
        lowerBound: number,
        upperBound: number | null,
        label: string
    ) {
        this.id = id;
        this.lowerBound = lowerBound;
        this.upperBound = upperBound;
        this.label = label;
    }

    get inferrredSize(): number {
        return (this.lowerBound + (this.upperBound ?? this.lowerBound)) / 2;
    }

    get sizeRange(): string {
        return this.upperBound
            ? `${numberFormatter.toTruncatedInteger(this.lowerBound)} - ${numberFormatter.toTruncatedInteger(this.upperBound)} ft²`
            : `> ${numberFormatter.toTruncatedInteger(this.lowerBound)} ft²`;
    }
}

const capitaliseFirstLetter = (str: string): string => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};

export const loadSizeBuckets = (): AppThunk<Promise<SizeBucket[]>> => async (dispatch) => {
    try {
        const query: Query = {
            dimensions: [
                "SizeBuckets.SizeBucketId",
                "SizeBuckets.LowerBound",
                "SizeBuckets.UpperBound",
                "SizeBuckets.SizeLabel",
            ]
        };

        const resultSet = await dispatch(cubeLoad(query)) as unknown as ResultSet;
        return resultSet.rawData().map(row => new SizeBucket(
            Number(row["SizeBuckets.SizeBucketId"]),
            Number(row["SizeBuckets.LowerBound"]),
            Number(row["SizeBuckets.UpperBound"]),
            capitaliseFirstLetter(String(row["SizeBuckets.SizeLabel"]))
        ));
    } catch (error) {
        dispatch(logError("Error loading Size Buckets.", error));
        throw error;
    }
};
